<template>
    <ValidationProvider
        v-slot="{ classes, errors }"
        ref="provider"
        :rules="rules"
        :custom-messages="customMessages"
        :name="name"
        :mode="custom"
        :class="$attrs['class']"
        tag="div"
    >
        <div class="digi-date" :class="classes">
            <label class="form-label font-inter text-viva-money-black font-bold" :for="name" v-html="errors[0] || label"></label>
            <div class="form-input flex flex-no-wrap -mx-2 max-w-none">
                <div class="flex form-input-inner p-2 w-1/3 font-inter text-viva-money-black">
                    <input type="hidden" v-model="sortcode" :name="name" />
                    <div class="input-wrapper w-full relative">
                        <input
                            type="tel"
                            placeholder
                            class="textbox bg-white h-12 w-full border-viva-money-black border-2 focus:border-viva-money-secondary-yellow outline-none p-2 text-center font-inter text-viva-money-black"
                            maxlength="2"
                            v-number-only="true"
                            @input="handleInput($event, 1)"
                            @change="handleChange($event, 1)"
                            v-model="partOne"
                            ref="sortcodePartOne"
                        />
                    </div>
                </div>
                <div class="flex justify-center items-center">&nbsp;&mdash;&nbsp;</div>
                <div class="flex form-input-inner p-2 w-1/3">
                    <div class="input-wrapper w-full relative">
                        <input
                            type="tel"
                            placeholder
                            class="textbox bg-white h-12 w-full border-viva-money-black border-2 focus:border-viva-money-secondary-yellow font-inter text-viva-money-black outline-none p-2 text-center"
                            maxlength="2"
                            v-number-only="true"
                            @input="handleInput($event, 2)"
                            @change="handleChange($event, 2)"
                            v-model="partTwo"
                            ref="sortcodePartTwo"
                        />
                    </div>
                </div>
                <div class="flex justify-center items-center">&nbsp;&mdash;&nbsp;</div>
                <div class="flex form-input-inner p-2 w-1/3">
                    <div class="input-wrapper w-full relative">
                        <input
                            type="tel"
                            placeholder
                            class="textbox bg-white h-12 w-full border-viva-money-black border-2 focus:border-viva-money-secondary-yellow font-inter text-viva-money-black outline-none p-2 text-center"
                            maxlength="2"
                            v-number-only="true"
                            @input="handleInput($event, 3)"
                            @change="handleChange($event, 3)"
                            v-model="partThree"
                            ref="sortcodePartThree"
                        />
                    </div>
                </div>
            </div>
            <div v-if="microText" class="form-microtext mt-4">
                <small v-html="microText"></small>
            </div>
        </div>
    </ValidationProvider>
</template>
 
<script>
export default {
    data() {
        return {
            sortcode: "",
            partOne: null,
            partTwo: null,
            partThree: null,
        };
    },
    props: {
        rules: {
            default: () => {
                return {};
            },
        },
        customMessages: {
            default: () => {
                return {};
            },
        },
        attributes: {
            default: () => {
                return {};
            },
        },
        value: {
            default: "",
        },
        name: {
            default: "",
        },
        label: {
            default: "",
        },
        options: {
            default: () => {
                return {};
            },
            type: Object,
        },
        type: {
            default: "text",
        },
        microText: {
            default: null,
        },
    },
    created() {
        if (this.value && /^\d{6}$/.test(this.value)) {
            this.sortcode = this.value;
            this.partOne = this.value.substr(0, 2);
            this.partTwo = this.value.substr(2, 2);
            this.partThree = this.value.substr(4, 2);
        }
    },
    methods: {
        custom(context) {
            return {
                on: ["change"],
            };
        },
        handleChange(event, part) {
            if (this.partOne && this.partTwo && this.partThree) {
                this.sortcode =
                    this.partOne.toString() +
                    this.partTwo.toString() +
                    this.partThree.toString();
                this.$refs.provider.validate(this.sortcode);
                this.$emit("input", this.sortcode);
            }
        },
        handleInput(event, part) {
            let value = event.target.value;
            if (value.toString().length === 2) {
                // Go to the next field
                if (part == 1) {
                    this.$refs["sortcodePartTwo"].focus();
                }
                if (part == 2) {
                    this.$refs["sortcodePartThree"].focus();
                }
            }
            if (
                this.partOne &&
                this.partTwo &&
                this.partThree &&
                /^[0-9]{2}$/.test(this.partOne) &&
                /^[0-9]{2}$/.test(this.partTwo) &&
                /^[0-9]{2}$/.test(this.partThree)
            ) {
                this.sortcode =
                    this.partOne.toString() +
                    this.partTwo.toString() +
                    this.partThree.toString();
                this.$refs.provider.validate(this.sortcode);
                setTimeout(() => {
                    window.amplitude.sortCodeInteractionEvent(this.$refs.provider.flags.valid === true ? 'valid' : 'invalid');
                }, 500)
                this.$emit("input", this.sortcode);
            } else {
                this.sortcode = null;
                this.$emit("input", this.sortcode);
            }
        },
    },
};
</script>
<style lang="scss">
.digi-sortcode.valid {
    .textbox {
        box-shadow: inset 0 0 0 1px #F0BA46;
        border-color: #F0BA46;
        border-width: 1px;
    }
}

.digi-sortcode.invalid {
    .textbox {
        box-shadow: inset 0 0 0 1px #FF6B6C;
        border-color: #FF6B6C;
        border-width: 1px;
    }
}
</style>